import React from 'react'

export default ({ children }) => (
    <div className="cardGrid">
        {children}
    </div>
)
